import HBIcon from "@/components/HBIcon";
import Image from "@/components/Image";
import Pay from "@/components/Pay";
import { gdImgSrcPolicy } from "@/utils/imageUrl";
import styles from "./index.module.less";

export default function ExpVip({ good, onOrderDone, onCancel }) {
  if (!good) return null;

  const skuParam = {
    skus: [{ sku_id: good.skus[0].id, is_upgrade: false }],
    scene: "normal",
    isVip: false,
  };

  return (
    <div className={styles.expVip}>
      <div className={styles.left}>
        <h2>还在犹豫？先体验一下</h2>
        <h1>
          3天体验VIP
          <Image
            {...gdImgSrcPolicy(
              "https://st0.dancf.com/static/02/202205110506-6a1c.png",
              {
                displayWidth: 76,
              }
            )}
            alt="价格图标"
          />
        </h1>
        <ul>
          <li>
            <HBIcon type="ic_check_circle" /> 每天可下载5个素材
          </li>
          <li>
            <HBIcon type="ic_check_circle" /> 商用授权给个人
          </li>
        </ul>
        <div className={styles.btn} onClick={onCancel}>
          放弃机会
        </div>
      </div>

      <div className={styles.right}>
        <div>扫码立即开通</div>
        <div className={styles.price}>¥{good.skus[0].price}</div>
        <Pay
          skuParam={skuParam}
          padding={0}
          size={100}
          style={{ boxShadow: "none" }}
          onPaid={onOrderDone}
          data-gd-expose="pay_expose"
          data-order-type="体验会员"
        />
        <div className={styles.payFn}>
          <HBIcon
            type="a-icon-wechatpay"
            style={{ color: "#59CC0D", paddingRight: 4, fontSize: "16px" }}
          />
          <HBIcon
            type="a-icon-alipay"
            style={{ color: "#06B4FD", paddingRight: 4, fontSize: "16px" }}
          />
          扫码支付
        </div>
        <div className={styles.agreement}>
          支付即视为您同意
          <a
            href="/about/disclaimer?activeKey=2"
            target="_blank"
            rel="noreferrer"
          >
            《花瓣素材会员服务协议》
          </a>
          和
          <a
            href="/about/disclaimer?activeKey=6"
            target="_blank"
            rel="noreferrer"
          >
            《花瓣个人会员授权许可协议》
          </a>
        </div>
      </div>
    </div>
  );
}
